import { Col, Row } from 'react-bootstrap';
import Marquee from 'react-fast-marquee';

const BrandTickerNew = () => {
  return (
    <div className=' w-100 brandTickerNew'>
      <h2 className=''>As seen on</h2>
      <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
        <Marquee
          style={{
            backgroundColor: 'transparent',
            display: 'flex',
            margin: ' 2.5rem 0',
          }}
        >
          <img
            src='/assets/icons/brands/brand1.png'
            alt='The Chronicle Journal'
            style={{ height: 35, width: 193 }}
          />{' '}
          <img
            src='/assets/icons/brands/brand5.png'
            alt='abc'
            style={{ height: 56, width: 126 }}
          />
          <img
            src='/assets/icons/brands/brand2.png'
            alt='Business Insurance'
            style={{ height: 24, width: 338 }}
          />
          <img
            alt='CBS'
            src='/assets/icons/brands/brand6.png'
            style={{ height: 48, width: 165 }}
          />
          <img
            src='/assets/icons/brands/brand3.png'
            alt='The Minnesota Star Tribune'
            style={{ height: 48, width: 112 }}
          />
          <img
            alt='NBC'
            src='/assets/icons/brands/brand7.png'
            style={{ height: 48, width: 218 }}
          />
          <img
            src='/assets/icons/brands/brand4.png'
            alt='MPS Egg Farms'
            style={{ height: 48, width: 120 }}
          />
          <img
            src='/assets/icons/brands/brand1.png'
            alt='The Chronicle Journal'
            style={{ height: 35, width: 193 }}
          />{' '}
          <img
            src='/assets/icons/brands/brand5.png'
            alt='abc'
            style={{ height: 56, width: 126 }}
          />
          <img
            src='/assets/icons/brands/brand2.png'
            alt='Business Insurance'
            style={{ height: 24, width: 338 }}
          />
          <img
            alt='CBS'
            src='/assets/icons/brands/brand6.png'
            style={{ height: 48, width: 165 }}
          />
          <img
            src='/assets/icons/brands/brand3.png'
            alt='The Minnesota Star Tribune'
            style={{ height: 48, width: 112 }}
          />
          <img
            alt='NBC'
            src='/assets/icons/brands/brand7.png'
            style={{ height: 48, width: 218 }}
          />
          <img
            src='/assets/icons/brands/brand4.png'
            alt='MPS Egg Farms'
            style={{ height: 48, width: 120 }}
          />
        </Marquee>

        <p>& over 300 news sites</p>
      </div>
    </div>
  );
};

export default BrandTickerNew;
